import React from "react";
import { useForm } from "react-final-form";
import { MaterialColorSelectField } from "@syos-music/instruments";
import { SelectField } from "@syos-music/form";

import { Grid, MenuItem } from "@mui/material";

import ProductSelectField from "components/form/ProductSelectField";
import SignatureMouthpieceSelectField from "components/signatureMouthpiece/SignatureMouthpieceSelectField";

export default function CartItemConstraintField({ name }) {
  const form = useForm();

  const type = form.getFieldState(`${name}.type`)?.value;
  const optionField = form.getFieldState(`${name}.option.field`)?.value;
  const optionOperator = form.getFieldState(`${name}.option.operator`)?.value;

  return (
    <Grid container>
      <Grid item xs={12} sm={4}>
        <SelectField name={`${name}.type`} required label="Type de contrainte">
          <MenuItem value="product">Sur un produit</MenuItem>
          <MenuItem value="option">Sur une option</MenuItem>
        </SelectField>
      </Grid>

      {type === "product" && (
        <Grid item xs={12} sm={8}>
          <Grid container>
            <Grid item xs={6}>
              <SelectField
                name={`${name}.product.operator`}
                required
                label="Operateur"
              >
                <MenuItem value="eq">Égale</MenuItem>
                <MenuItem value="neq">Non égale</MenuItem>
              </SelectField>
            </Grid>

            <Grid item xs={6}>
              <ProductSelectField
                name={`${name}.product.product`}
                required
                label="Produit"
              />
            </Grid>
          </Grid>
        </Grid>
      )}

      {type === "option" && (
        <Grid item xs={12} sm={8}>
          <Grid container>
            <Grid item xs={4}>
              <SelectField
                name={`${name}.option.field`}
                required
                label="Option"
              >
                <MenuItem value="mouthpieceColor">Couleur du bec</MenuItem>
                <MenuItem value="signatureMouthpieceId">Signature</MenuItem>
              </SelectField>
            </Grid>

            <Grid item xs={4}>
              <SelectField
                name={`${name}.option.operator`}
                required
                label="Operateur"
              >
                <MenuItem value="eq">Égale</MenuItem>
                <MenuItem value="neq">Non égale</MenuItem>
                <MenuItem value="exists">Extiste</MenuItem>
              </SelectField>
            </Grid>

            <Grid item xs={4}>
              {optionOperator === "exists" && (
                <SelectField
                  name={`${name}.option.value`}
                  required
                  label="Operateur"
                >
                  <MenuItem value="yes">Oui</MenuItem>
                  <MenuItem value="no">Non</MenuItem>
                </SelectField>
              )}

              {(optionOperator === "eq" || optionOperator === "neq") && (
                <>
                  {optionField === "mouthpieceColor" && (
                    <MaterialColorSelectField
                      name={`${name}.option.value`}
                      required
                      allowPrivate
                    />
                  )}

                  {optionField === "signatureMouthpieceId" && (
                    <SignatureMouthpieceSelectField
                      name={`${name}.option.value`}
                      required
                    />
                  )}
                </>
              )}
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}
